import { Route, Routes, useLocation } from "react-router-dom";
import { _routes } from "Explore/Routes/routes";
import styles from "./Content.module.scss";
import { useDispatch } from "react-redux";
import { setUseGreyBg } from "Redux/Slices/Common";
import { useEffect, useMemo } from "react";
import { Container } from "@mui/material";
import useAuth from "Hooks/useAuth";

export const LAYOUT_CONTENT_DECOR_ANCHOR_ID = "layout-decor-anchor";

const Content = () => {
  const { userRole } = useAuth();
  const dispatch = useDispatch();
  const entity = useLocation().pathname.split("/")[2];
  const id = useLocation().pathname.split("/")[3];
  const { content_className, maxWidth, useGreyBg } = useMemo(() => {
    let maxWidth = "lg";
    let content_className = "content";
    let useGreyBg = false;
    if (!entity) {
      content_className = "content-homepage";
    } else if (entity == "faculty" && id) {
      content_className = "content-faculty-detail";
    } else if (entity == "institution" && id) {
      content_className = "content-institution-detail";
      maxWidth = false;
    } else if (entity == "unit" && id) {
      content_className = "content-unit-detail";
      maxWidth = false;
    } else if (entity == "concept" && id) {
      content_className = "content-concept-detail";
    } else if (entity == "venue") {
      content_className = "content-venue-detail";
    } else if (entity == "faculties") {
      maxWidth = "xl";
      content_className = "content-faculty";
      useGreyBg = true;
    } else if (entity == "institutions") {
      maxWidth = "xl";
      useGreyBg = true;
    } else if (entity == "units") {
      maxWidth = "xl";
      useGreyBg = true;
      content_className = "content-unit";
    } else if (entity == "venues") {
      maxWidth = "xl";
      useGreyBg = true;
      content_className = "content-venue";
    } else if (["overview", "analysis", "peer", "report-detail", "collaborations", "geographical-collaboration", "current-collaborations", "potential-collaborations", "my-library", "export-center", "settings", "mcp", "mcp-server"].includes(entity)) {
      maxWidth = false;
      content_className = "content-collaborations";
    } else if (entity == "report") {
      maxWidth = false;
      content_className = "content-report";
    } else if (entity == "assistant") {
      maxWidth = false;
      content_className = "content-assistant";
    }

    return { content_className, maxWidth, useGreyBg };
  }, [entity, id]);

  useEffect(() => {
    dispatch(setUseGreyBg(useGreyBg));
  }, [dispatch, useGreyBg]);

  console.log('entity: ', entity)

  if (entity === 'keyword-benchmarking' || window.location.pathname.includes('/explore/admin')) {
    return <>
      <div className={styles["content-container"]}>
        <Routes>
          {_routes({ userRole }).map((route, index) => {
            return (
              <Route
                path={route.path}
                exact
                element={<route.component />}
                key={index}
              />
            );
          })}
        </Routes>
      </div>
    </>
  }

  return (
    <Container maxWidth={maxWidth} className={styles[`${content_className}`]}>
      {/* <div
        className={styles["content-decoration"]}
        style={{
          height:
            (document
              .getElementById(LAYOUT_CONTENT_DECOR_ANCHOR_ID)
              ?.getBoundingClientRect()?.bottom || 200) + window.scrollY,
        }}
      /> */}
      <div className={styles["content-container"]}>
        <Routes>
          {_routes({ userRole }).map((route, index) => {
            return (
              <Route
                path={route.path}
                exact
                element={<route.component />}
                key={index}
              />
            );
          })}
        </Routes>
      </div>
    </Container>
  );
};

export default Content;
